import { useState, useEffect } from 'react';
import { Storage } from 'aws-amplify';

export default function ImageS3({
  src: rawSrc,
  ...props
}: React.ImgHTMLAttributes<HTMLImageElement>) {
  const [src, setSrc] = useState('');

  useEffect(() => {
    if (rawSrc) {
      Storage.get(rawSrc)
        .then((signedPath: unknown) => {
          // aws-amplify return ts type is incorrectly set to Object
          setSrc(signedPath as string);
        })
        // eslint-disable-next-line no-console
        .catch((err: any) => console.error(err));
    } else {
      setSrc('');
    }
  }, [rawSrc]);

  // eslint-disable-next-line jsx-a11y/alt-text
  return <img {...props} src={src} />;
}
